import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { toast } from "react-toastify";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { getBikeHistoryList } from "actions/bike-history/actions";

import ModalBikeLastPosition from "views/pages/bikes-history/modal-bike-last-position";
import CommonTable from "../../lib/components/CommonTable";
import Filters from "./filters";

const BikeHistory = ({
                        list,
                        getList,
                        ...rest
                      }) => {
  const handleOpenMap = (position) => {
    if (!position.coordinates || !Array.isArray(position.coordinates)) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "bike-history-position",
      modalSettings: {
        size: "sm"
      },
      header: "Bike last position",
      children: (
        <ModalBikeLastPosition
          coordinates={position.coordinates}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
    },
    {
      id: "username",
      Header: "Username",
      accessor: "username",
    },
    {
      id: "bikeId",
      Header: "Bike ID",
      accessor: "bikeId",
    },
    {
      id: "bikeQr",
      Header: "Bike QR",
      accessor: "bikeQr",
    },
    {
      id: "date",
      Header: "Date",
      accessor: original => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "from",
      Header: "From",
      accessor: "from",
    },
    {
      id: "to",
      Header: "To",
      accessor: "to",
    },
    {
      id: "position",
      Header: "Position",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenMap(original.position)}
          title="Bike last position"
        >
          <FontAwesomeIcon icon={faMapMarker}/>
        </button>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={Filters}
      searchHookProps={{
        size: 20,
        sort: "date,DESC"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.bikeHistory.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getBikeHistoryList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(BikeHistory);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-history/index.js